<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" />
</template>

<script lang="ts">
    import { Component, Watch, Vue, Inject } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";
    @Component({
        components: {
            MenuList,
        },
    })
    export default class HelpDrops extends Vue {
        @Inject()
        ["showMessage"];
        showHelp = !appConfig.isBuild;
        showLangs = !appConfig.isBuild;

        activeKey = "";

        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }

        @Watch("showDropdown")
        changeLayerOpertaion(val) {
            if (!val) {
                this.activeKey = "";
            }
        }

        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }

        get menuList() {
            return this.internal ? this.menuListCN : this.menuListEN;
        }
        get menuListCN() {
            let list = [
                { key: "findFuc", isRender: !this.isFocusMode },
                {
                    key: "optGuides",
                    isRender: this.internal && !this.isPlugin && !window.EDCONFIG.IS_SDK,
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "helpGuides" && "activeFunc",
                },
                {
                    key: "video2",
                    isRender: !this.isPlugin && !this.isWorkwx && !window.EDCONFIG.IS_SDK,
                    extraClass: this.activeFunc == "helpVideo" && "activeFunc",
                },
                { key: "function1", isRender: !this.isPlugin && !this.isWorkwx && !window.EDCONFIG.IS_SDK },
                { key: "function2", isRender: !this.isPlugin && !this.isPrivate && !window.EDCONFIG.IS_SDK },
                { key: "shortcut", extraClass: this.activeFunc == "helpShortKey" && "activeFunc" },
                {
                    key: "helpCenter",
                    isRender: !this.isPlugin && !this.isPrivate && !window.EDCONFIG.IS_SDK,
                    extraClass: this.activeFunc == "helpCenter" && "activeFunc",
                },
                {
                    key: "feedback",
                    isRender: !this.isPlugin && !this.isPrivate && !window.EDCONFIG.IS_SDK,
                    extraClass: this.activeFunc == "helpReportError" && "activeFunc",
                },
                { key: "language", isRender: this.showLangs && !window.EDCONFIG.IS_SDK, expand: true, active: false },
            ];

            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });
            let feedbackLabel = this.internal ? this.$t("feedback") : this.$t("reportError");
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(Object.assign({}, item, { label: item.key == "feedback" ? feedbackLabel : this.$t(item.key) }));
            });
            return { container: "insert-drops", list: resultList };
        }
        get menuListEN() {
            let list = [
                { key: "findFuc", isRender: !this.isFocusMode && !this.isTeamsApp },
                { key: "starterGuide", isRender: !this.isFocusMode && !window.EDCONFIG.IS_SDK },
                { key: "helpCenter", extraClass: this.activeFunc == "helpCenter" && "activeFunc", isRender: !this.isTeamsApp },
                { key: "shortcut", extraClass: this.activeFunc == "helpShortKey" && "activeFunc" },
                { key: "feedback", extraClass: this.activeFunc == "helpReportError" && "activeFunc", isRender: !this.isTeamsApp },
            ];

            let feedbackLabel = this.internal ? this.$t("feedback") : this.$t("reportError");
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(Object.assign({}, item, { label: item.key == "feedback" ? feedbackLabel : this.$t(item.key) }));
            });
            return { container: "help-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0];
            let clickEvents = new Map([
                [
                    "findFuc",
                    () => {
                        this.showSearch();
                    },
                ],
                [
                    "video2",
                    () => {
                        this.clickHelpMenu("video2");
                    },
                ],
                [
                    "function1",
                    () => {
                        this.clickHelpMenu("function1");
                    },
                ],
                [
                    "function2",
                    () => {
                        this.clickHelpMenu("function2");
                    },
                ],
                [
                    "shortcut",
                    () => {
                        this.showShortCut();
                    },
                ],
                [
                    "helpCenter",
                    () => {
                        this.openHelp();
                    },
                ],
                [
                    "feedback",
                    () => {
                        this.openReportError();
                    },
                ],
                [
                    "starterGuide",
                    () => {
                        this.$bus.$emit("showShepherd");
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = key;
            this.showExpand(event, key);
        }
        showSearch() {
            this.closeDrop();
            this.$track("menu", "help", "showSearch");
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "SearchFunc",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        clickHelpMenu(type) {
            let url = "";
            switch (type) {
                case "video2":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/video` : "https://www.edrawmax.cn/helpcenter/web/video";
                    break;
                case "function1":
                    url = this.isPrivate
                        ? `${this.urls.helpcenterUrl}/help/web/video?class=basic`
                        : "https://www.edrawmax.cn/helpcenter/web/video?class=basic";
                    break;
                case "function2":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/releases` : "https://www.edrawmax.cn/helpcenter/web/releases";
                    break;
                case "help":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/home` : "https://www.edrawmax.cn/helpcenter/web/home";
                    break;
                case "refeed":
                    url = "https://www.edrawmax.cn/feedback/web/post";
                    break;
            }
            window.open(url);
            this.closeDrop();
        }
        showExpand(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["optGuides", "language"].includes(type)) {
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: true,
                });
            }
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        showShortCut() {
            this.showDialog("Hotkey");
            this.$track("menu", "help", "Hotkey");
            this.closeDrop();
        }
        openHelp() {
            let url = this.internal
                ? this.isPrivate
                    ? `${this.urls.helpcenterUrl}/help/web/home`
                    : "https://www.edrawmax.cn/helpcenter/web/home"
                : "https://www.edrawsoft.com/guide/edrawmax-online/";

            let newTab = window.open("about:blank");
            newTab.location.href = url;

            this.$track("menu", "help", "openHelp");
            this.closeDrop();
        }
        // openStarterGuide(){
        //   this.$bus.$emit("starterGuide")
        //   this.$track('menu', 'help', 'starterGuide');
        // 	this.closeDrop();
        // }
        openReportError() {
            let url = this.internal ? "https://www.edrawmax.cn/feedback/web/help/" : "https://www.edrawmax.com/feedback/web/post";
            let newTab = window.open("about:blank");
            newTab.location.href = url;

            this.$track("menu", "help", "openReportError");
            this.closeDrop();
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }

        mounted() {}

        created() {}
        deactivated() {
            this.activeKey = "";
        }
    }
</script>
<i18n>
{
  "zh": {
    "findFuc": "功能查找",
    "helpCenter": "帮助中心",
    "optGuides": "新手教程",
    "starterGuide": "新手向导",
    "shortcut": "快捷键",
    "reportError": "反馈中心",
    "language": "切换语言",
    "update": "检查更新",
    "newest": "已是最新版本",
    "updateNow": "现在更新?",
    "video2": "视频教程",
    "function1": "功能教程",
    "function2": "新功能",
    "feedback": "反馈中心"
  },
  "en": {
    "findFuc": "Search Function",
    "helpCenter": "Help Center",
    "optGuides": "Operation Guide",
    "starterGuide": "Started Guide",
    "shortcut": "Shortcut Key",
    "reportError": "Feedback",
    "language": "Change Language",
    "update": "Check for Updates",
    "newest": "Latest",
    "updateNow": "Update Now?",
    "video2": "Video Tutorial",
    "function1": "Function Tutorial",
    "function2": "What’s New",
    "feedback": "Feedback"
  },
  "fr": {
    "findFuc": "Recherche de fonctionnalités",
    "helpCenter": "Centre d'aide",
    "optGuides": "Guide d'opération",
    "starterGuide": "Guide novice",
    "shortcut": "Raccourci",
    "reportError": "Centre de rétroaction",
    "language": "Changer de langue",
    "update": "Vérifier les mises à jour",
    "newest": "Dernière",
    "video2": "Vidéo tutoriel",
    "function1": "Tutoriel sur les fonctions",
    "function2": "Quoi de neuf",
    "updateNow": "Mettre à jour maintenant?"
  },
  "de": {
    "findFuc": "Suche",
    "helpCenter": "Hilfezentrum",
    "optGuides": "Gebrauchsanleitung",
    "starterGuide": "Anfängerführung",
    "shortcut": "Tastenkombinationen",
    "reportError": "Rückmeldung",
    "language": "Sprache",
    "update": "Update",
    "newest": "Neueste Version",
    "video2": "Video Anleitung",
    "function1": "Funktionstutorial",
    "function2": "Was neu ist",
    "updateNow": "Jetzt updaten?"
  },
  "jp": {
    "findFuc": "機能を検索",
    "helpCenter": "ヘルプ",
    "optGuides": "操作ガイド",
    "starterGuide": "スタートガイド",
    "shortcut": "ショートカット",
    "reportError": "フィードバック",
    "language": "言語の変更",
    "update": "アップデートを確認",
    "newest": "ご利用いただいているのは最新バージョンです",
    "video2": "チュートリアル",
    "function1": "使い方とコツ",
    "function2": "新機能",
    "updateNow": "今すぐ更新しますか？"
  },
  "es": {
    "findFuc": "Función de búsqueda",
    "helpCenter": "Centro de ayuda",
    "optGuides": "Manual de operaciones",
    "starterGuide": "Guía del novato",
    "shortcut": "Tecla de atajo",
    "reportError": "Comentarios",
    "language": "Lenguaje",
    "update": "Revise las actualizaciones",
    "newest": "Último",
    "video2": "Video Tutorial",
    "function1": "Tutorial de funciones",
    "function2": "Qué hay de nuevo",
    "updateNow": "¿Actualizar ahora?"
  },
  "pt": {
    "findFuc": "Encontrar Função",
    "helpCenter": "Centro de Ajuda",
    "optGuides": "Guia de Operação",
    "starterGuide": "Guia Iniciado",
    "shortcut": "Tecla de Atalho",
    "reportError": "Feedback",
    "language": "Língua",
    "update": "Verificar por Atualizações",
    "newest": "Mais Recente",
    "video2": "Vídeo Tutorial",
    "function1": "Tutorial de Função",
    "function2": "O que há de novo",
    "updateNow": "Atualizar já?"
  },
  "it": {
    "findFuc": "Trova Funzioni",
    "helpCenter": "Centro di Supporto",
    "optGuides": "Guida operativa",
    "starterGuide": "Guida per principianti",
    "shortcut": "Scorciatoie di Tastiera",
    "reportError": "Feedback",
    "language": "Lingua",
    "update": "Verifica Disponibilità Aggiornamenti",
    "newest": "Più Recente",
    "video2": "Tutorial Video",
    "function1": "Tutorial di Funzione",
    "function2": "Cosa nuova c'è ",
    "updateNow": "Desideri Aggiornare?"
  },
  "tw": {
    "findFuc": "功能查找",
    "helpCenter": "幫助中心",
    "optGuides": "操作指引",
    "starterGuide": "新手嚮導",
    "shortcut": "快速鍵",
    "reportError": "反饋中心",
    "language": "切換語言",
    "update": "檢查更新",
    "newest": "已是最新版本",
    "updateNow": "現在更新?"
  }
}
</i18n>
